import React from 'react';
import { Col, Row } from 'reactstrap';

import DailyQuizHistory from '../../containers/DashboardContainers/dailyQuizHistoryContainer';
import history from '../../utils/history';
import CircularLoading from '../Common/CircularLoading/CircularLoading';
import { Desktop, Mobile } from '../Common/const';
import PfeSktSwitch from '../Common/PfeSktSwitch/PfeSktSwitch';
import NotificationPopUp from '../Headers/NotificationPopUp';
import NotificationPopUpFree from '../Headers/NotificationPopUpFree';
import calendarImg from '../Sidebar/assets/calendar.png';
import CircularProgressBar from '../Sidebar/CircularProgressBar';

class DailyQuizPageView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFreePopUpModal: false,
      showCancelPopUp: false,
    };
  }

  componentDidMount() {
    this.props.checkDailyQuizStatus();
  }

  getActiveTab = () => {
    const { pfeSktId, user } = this.props;
    if (pfeSktId && user?.rate?.id && pfeSktId === user.rate.id) {
      return 'SKT';
    }
    return 'PFE';
  };

  handleTabSwitch = (tab) => {
    const { user } = this.props;
    if (!user) return;

    if (tab === 'SKT') {
      this.props.setSwitchPfeSkt(user.rate.id);
    } else {
      this.props.setSwitchPfeSkt(user.pfeRate.id);
    }
  };

  componentDidUpdate(prevProps) {
    // After the backend finishes updating the rate, refresh status and history
    if (prevProps.pfeSktId !== this.props.pfeSktId) {
      this.props.checkDailyQuizStatus();
      this.props.refreshDailyQuizHistory();
    }
  }

  getMinutesOrHours(hours) {
    if (hours > 0 && hours < 1) {
      const minutes = Math.ceil(hours * 60);
      if (minutes === 1) {
        return `${minutes} Min`;
      }
      return `${minutes} Mins`;
    }
    if (hours === 1) {
      return `${hours} HR`;
    }
    return `${hours} HRS`;
  }

  handleOnStartQuiz = () => {
    const { user } = this.props;
    if (user?.id) {
      if (user.isFreeAccount) {
        this.setState({ showFreePopUpModal: true });
      } else if (!user.active) {
        this.setState({ showCancelPopUp: true });
      } else {
        if (this.props.dailyQuizRunning || this.props.nextQuizIn === 0) {
          history.push('/app/daily20quiz');
        }
      }
    }
  };

  getLaunchButtonText = () => {
    const { checkDailyQuizStatusWaiting, dailyQuizRunning, nextQuizIn } =
      this.props;

    if (checkDailyQuizStatusWaiting) {
      return <CircularLoading className="button-loading-gif" />;
    }
    if (dailyQuizRunning) {
      return `${dailyQuizRunning} QUESTIONS REMAINING`;
    }
    if (nextQuizIn > 0) {
      return `NEXT QUIZ IN ${this.getMinutesOrHours(nextQuizIn)}`;
    }
    if (nextQuizIn === -1) {
      return 'QUIZ NOT AVAILABLE';
    }
    return 'LAUNCH DAILY QUIZ';
  };

  isQuizButtonEnabled = () => {
    const { checkDailyQuizStatusWaiting, nextQuizIn, dailyQuizRunning } =
      this.props;
    if (checkDailyQuizStatusWaiting) return false;
    // Enabled only when quiz is available (nextQuizIn === 0) or in progress (dailyQuizRunning > 0)
    return nextQuizIn === 0 || dailyQuizRunning > 0;
  };

  render() {
    const activeTab = this.getActiveTab();
    const isEnabled = this.isQuizButtonEnabled();
    const circularProgress = this.props.progress || 0;
    const sktLocked =
      !this.props.userSubscription?.isOccupational ||
      this.props.user?.rate?.isPfeOnly;

    return (
      <div className="daily-quiz-page-container">
        {/* Desktop Layout */}
        <Desktop>
          <Row className="daily-quiz-launch-section m-0">
            <Col
              xs={6}
              className="d-flex justify-content-start align-items-center p-0"
            >
              {/* Hidde for now
               <CircularProgressBar
                strokeWidth="8"
                sqSize="111"
                imgSrc={calendarImg}
                percentage={circularProgress}
              /> */}

              <button
                // className={`btn ${isEnabled ? 'btn-outline-secondary' : 'btn-outline-download'} rounded-lg border-0 daily-quiz-launch-btn`}
                className="btn rounded border-0 daily-quiz-launch-btn"
                onClick={isEnabled ? this.handleOnStartQuiz : null}
              >
                {this.getLaunchButtonText()}
              </button>
            </Col>
            <Col
              xs={6}
              className="d-flex justify-content-end align-items-center p-0"
            >
              <PfeSktSwitch
                activeTab={activeTab}
                onSwitch={this.handleTabSwitch}
                variant="toggle"
                size="md"
                sktLocked={sktLocked}
              />
            </Col>
          </Row>
        </Desktop>

        {/* Mobile Layout */}
        <Mobile>
          <div className="daily-quiz-mobile-section">
            <div className="d-flex justify-content-center mb-3">
              <PfeSktSwitch
                activeTab={activeTab}
                onSwitch={this.handleTabSwitch}
                variant="toggle"
                size="md"
                sktLocked={sktLocked}
              />
            </div>
            <div className="d-flex justify-content-center">
              <button
                // className={`btn ${isEnabled ? 'btn-outline-secondary' : 'btn-outline-download'} rounded-lg daily-quiz-launch-btn`}
                className="btn rounded border-0 daily-quiz-launch-btn"
                onClick={isEnabled ? this.handleOnStartQuiz : null}
              >
                {this.getLaunchButtonText()}
              </button>
            </div>
          </div>
        </Mobile>

        {/* Quiz History Section */}
        <div className="daily-quiz-history-section">
          <DailyQuizHistory batch={3} />
        </div>

        {/* Modals */}
        <NotificationPopUpFree
          isOpen={this.state.showFreePopUpModal}
          openFreePopUp={(value) =>
            this.setState({ showFreePopUpModal: value })
          }
        />
        <NotificationPopUp
          isOpen={this.state.showCancelPopUp}
          openCancelPopUp={(value) => this.setState({ showCancelPopUp: value })}
          user={this.props.user}
        />
      </div>
    );
  }
}

export default DailyQuizPageView;
